import { Component, OnInit } from '@angular/core';
import { ClientRequest } from 'src/app/data/api.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {
  constructor(private api: ClientRequest) { }

  newsList;
  type = { type: 'SUPPLIER' };

  classname = "footer-area footer-area-2 footer-area-1 bg_cover";
  ftbgimage = "assets/images/footer-bg.jpg";
  ftlogo = "assets/images/logo-1.1.png";
  ftshape = "d-none";
  ftcolor = '#ef7124';

  ngOnInit(): void {
    this.api.getReq(this.type).subscribe(
      (res : any) => {
        this.newsList = res.faqs;
      },
      (err) => {}
    );
  }

}
